<!--
Author: TangChen
Date: 2019-04-08
Desc: 图片上传
 -->
<template>
    <div class="comp-bankcard-upload comp">
        <el-row class="up-list" :span="24">
            <div class="img-up-box">
                <div class="img-up-list el-upload-list--picture-card">
                    <div
                        v-if="imgBase64.frontBank"
                        class="el-upload-list__item-actions"
                    >
                        <i
                            class="el-icon-zoom-in"
                            v-on:click="handlePictureCardPreview('frontBank')"
                        />
                        <i
                            class="el-icon-delete"
                            v-on:click="delImg('frontBank')"
                        />
                    </div>
                    <el-input
                        ref="frontBank"
                        v-model="img.frontBank"
                        type="file"
                        name="frontBank"
                        :accept="accept"
                        v-on:change="getImgBase"
                    />
                    <div class="img-up">
                        <img v-if="imgBase64.frontBank" :src="imgBase64.frontBank" />
                        <i v-if="!imgBase64.frontBank" class="el-icon-plus" />
                        <span v-if="!imgBase64.frontBank" class="desc">上传</span>
                    </div>
                </div>
                <div class="img-up-list el-upload-list--picture-card">
                    <div
                        v-if="imgBase64.backBank"
                        class="el-upload-list__item-actions"
                    >
                        <i
                            class="el-icon-zoom-in"
                            v-on:click="handlePictureCardPreview('backBank')"
                        />
                        <i class="el-icon-delete" v-on:click="delImg('backBank')" />
                    </div>
                    <el-input
                        ref="backBank"
                        v-model="img.backBank"
                        type="file"
                        name="backBank"
                        :accept="accept"
                        v-on:change="getImgBase"
                    />
                    <div class="img-up">
                        <img v-if="imgBase64.backBank" :src="imgBase64.backBank" />
                        <i v-if="!imgBase64.backBank" class="el-icon-plus" />
                        <span v-if="!imgBase64.backBank" class="desc">上传</span>
                    </div>
                </div>
            </div>
            <div class="upload-tip">
                上传的图片大小每张不能超过10M，格式类型只支持jpg，jpeg，png
            </div>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" />
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "BankcardUpload",
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            accept: "image/jpg,image/jpeg,image/png",
            img: {
                frontBank: "",
                backBank: ""
            },
            imgBase64: {
                frontBank: "",
                backBank: ""
            },
            upload_url: "/acct/changetype/upload",
            uploadForm: new FormData()
        };
    },
    watch: {
        "img.frontBank"(val) {
            this.img.idCard = val && this.img.backBank ? "1" : "";
        },
        "img.backBank"(val) {
            this.img.idCard = val && this.img.frontBank ? "1" : "";
        }
    },
    mounted() {},
    methods: {
        handlePictureCardPreview(filename) {
            this.dialogImageUrl = this.imgBase64[filename];
            this.dialogVisible = true;
        },
        validateImg(rule, value, callback) {
            if (value) {
                callback();
            } else {
                if (!this.img.frontBank && !this.img.backBank) {
                    callback(new Error("请上传银行卡正反面文件"));
                }
                if (!this.img.frontBank) {
                    callback(new Error("请上传银行卡正面文件"));
                }
                if (!this.img.backBank) {
                    callback(new Error("请上传银行卡反面文件"));
                }
            }
        },
        submitInfo() {
            const _this = this;
            const _x = this.$util.src(_this.upload_url, {}, true);
            _this.$refs.img.validate(valid => {
                if (valid) {
                    this.$req({
                        method: "POST",
                        url: _x,
                        timeout: 20000,
                        data: _this.imgBase64,
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                        .then(res => {
                            if (res.code === "0000000") {
                                _this.$emit("success", true);
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                        .catch(() => {});
                } else {
                    return false;
                }
            });
        },
        getImgBase() {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            if (
                !(
                    event.target.value.indexOf(".jpg") > -1 ||
                    event.target.value.indexOf(".jpeg") > -1 ||
                    event.target.value.indexOf(".png") > -1
                )
            ) {
                this.delImg(event.target.name);
                this.$message.warning("只能上传jpg/jpeg/png文件，请重新上传");
                return false;
            }
            if (file.size > 10 * 1024 * 1024) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小10M，不能上传");
                return;
            }
            for (let i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop())
                    k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function(e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
                _this.$emit("change", _this.imgBase64);
            };
            try {
                this.uploadForm.delete(event.target.name);
            } catch (e) {
                console.log(e);
            }
            this.uploadForm.append(event.target.name, file);
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg(index) {
            this.imgBase64[index] = "";
            this.$emit("change", this.imgBase64);
            if (this.img[index]) {
                this.img[index] = "";
                this.uploadForm.delete(index);
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-bankcard-upload {
    .up-list {
        padding-bottom: 20px;
        .up-list-mes {
            font-size: $f16;
            color: $text-color2;
            line-height: 30px;
        }
        .img-up-list {
            display: inline-block;
            position: relative;
            .el-upload-list__item-actions {
                z-index: 100;
                i {
                    font-size: $f24;
                    cursor: pointer;
                }
                i:last-of-type {
                    margin-left: 20px;
                }
            }
            .el-input {
                position: absolute;
                top: 10px;
                left: 0;
                opacity: 0;
                z-index: 10;
            }
            .img-up,
            .el-input .el-input__inner {
                width: 240px;
                height: 150px;
                line-height: 150px;
                cursor: pointer;
            }
            .img-up {
                text-align: center;
                border: 1px solid $border-color4;
                border-radius: 10px;
                background-color: $bg1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .desc {
                    font-size: 18px;
                    line-height: 30px;
                }
                img {
                    width: 240px;
                    height: 150px;
                    display: inline-block;
                }
            }
            .img-text {
                vertical-align: middle;
                font-size: $f20;
            }
            .el-icon-plus {
                vertical-align: middle;
                font-size: $f26;
                margin-right: 7px;
                color: inherit;
                font-weight: bold;
            }
        }
        .img-up-box {
            .img-up-list {
                vertical-align: middle;
                &:last-of-type {
                    margin-left: 24px;
                }
            }
        }
        .upload-tip {
          font-size: 16px;
          color: red;
        }
    }
}
</style>
